<template>
  <div class="py-4">
    <div class="p-2">
      <div class="flex py-2 gap-2 float-right flex-col">
        <router-link to="/dashboard/report/cleaning/new" class="bg-primary px-4 py-2 rounded flex float-right">
          <v-icon icon="material-symbols:add" class="text-2xl text-white mr-2" />
          <span class="text-white">Laporan</span>
        </router-link>
        <router-link to="/dashboard/report/inventory/new" class="bg-primary px-4 py-2 rounded flex float-right">
          <v-icon icon="material-symbols:add" class="text-2xl text-white mr-2" />
          <span class="text-white">Inventori</span>
        </router-link>
      </div>
      <h1 class="text-2xl font-bold">Laporan Kebersihan</h1>
      <p>Laporan kebersihan yang telah dibuat oleh pengguna.</p>
    </div>
    <template v-for="report in reports">
      <DropDown :key="report.date">
        <template #title>
          <span class="text-left">{{ report.location }}</span>
        </template>
        <template #default>
          <!-- Cleaning Report View based on report -->
          <div :key="report.id" class="p-4 border-b">
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-lg font-semibold">{{ report.title }}</h2>
                <p class="text-sm text-gray-600">{{ report.description }}</p>
              </div>
              <span class="text-sm text-gray-500">{{ iconParse(report.timestamp) }}</span>
            </div>
            <div class="mt-2">
              <template v-for="form in report.forms">
                <van-cell :title="form.title" :label="form.status" class="mt-2" :key="form.id">
                  <template #icon>
                    <v-icon icon="ph:check-circle" class="text-2xl my-auto ml-2 mr-4 text-success" />
                  </template>
                  <template #right-icon>
                    <div class="flex items-center -mr-2">
                      <div class="flex items-center bg-primary text-white rounded">
                        <v-icon icon="ph:eye-fill" class="text-xl my-auto ml-2" />
                        <span class="rounded-full px-3 py-2 text-sm"> Lihat</span>
                      </div>
                    </div>
                  </template>
                </van-cell>
              </template>
            </div>
          </div>
        </template>
      </DropDown>
    </template>
  </div>
</template>
<script>
  import DropDown from "@/components/DropDown.vue";
  import dayjs from "dayjs";

  export default {
    data() {
      return {
        reports: [
          {
            id: 1,
            location: "Toilet Pria Lt 1",
            title: "Toilet Pria Lt 1",
            description: "Generated Cleaning report.",
            forms: [
              // toilet, wastafel, urinoir
              {
                id: 1,
                title: "Toilet",
                before: "https://example.com/before.jpg",
                after: "https://example.com/after.jpg",
                timestamp: "2023-10-01T08:00:00Z",
                status: "Bersih"
              },
              {
                id: 2,
                title: "Wastafel",
                before: "https://example.com/before.jpg",
                after: "https://example.com/after.jpg",
                timestamp: "2023-10-01T08:05:00Z",
                status: "Bersih"
              },
              {
                id: 3,
                title: "Urinoir",
                before: "https://example.com/before.jpg",
                after: "https://example.com/after.jpg",
                timestamp: "2023-10-01T08:10:00Z",
                status: "Bersih"
              }
            ]
          }
        ]
      };
    },
    components: {
      DropDown
    },
    computed: {},
    methods: {
      iconParse(date) {
        const day = dayjs(date).format("HH:mm");
        return day;
      }
    }
  };
</script>
